import { useEffect, useState } from 'react';

const useTypewriter = (text: string | undefined, speed = 10): string => {
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    if (!text) {
      setDisplayText('');
      return;
    }

    setDisplayText('');

    let i = 0;
    const timer = window.setInterval(() => {
      i += 1;
      setDisplayText(text.slice(0, i));
      if (i >= text.length) {
        window.clearInterval(timer);
      }
    }, speed);

    return () => window.clearInterval(timer);
  }, [text, speed]);

  return displayText;
};

export default useTypewriter;
